import { animateTab } from './animate-tabs.js'
import { education } from './education.js'
import { header } from './header.js'
import './region.js'
import './updateLastInRow.js'

window.addEventListener('DOMContentLoaded', () => {
  animateTab()
  education()
  header()
})
